export default {
    Get: {
        NEW_PROPERTY: 'initProperty',
        PROPERTY_MODEL: 'getPropertyModel',
        LIST_OF_PROPERTY_DOCUMENTS: 'getListOfPropertyDocuments',
        LIST_OF_ADDRESSES: 'getListOfAddresses',
        LOCATION: 'getLocationByAddress',
        PROPERTY: 'getPropertyById',
        CONTENT_BY_TAB: 'getContentByTabName',
        MEDIA_PUBLIC_PLANS: "getMediaPublicPlans"
    },
    Set: {
        ASSIGNVALUE: "setValue",
        ASSIGNVALUE_TO_ORIGINOBJECT: "setValueForOriginalObject",
        DEEP_CLONE: 'deepClone',
        PROPERTY: 'setProperty',
        ORIGIN_PROPERTY: 'setOriginalProperty',
        ORIGIN_PROPERTY_AND_DIFF: 'setOriginalPropertyAndDiff',
        ASSIGNVALUE_PROPERTY: 'setPropertyPartial',
        ASSIGNVALUE_PROPERTY_MANAGEMENT: 'setPropertyManagementPartial',
        ASSIGNVALUE_PROPERTY_PROSPECTION: 'setPropertyProspectionPartial',
        ASSIGNVALUE_ORIGINAL_PROPERTY: 'setOriginalPropertyPartial',
        INSERT_PROPERTY: 'insertProperty',
        LIST_OF_PROPERTIES: 'setListOfProperties',
        ORIGIN_PROPERTY_MODEL: 'setOriginPropertyModel',
        PROPERTY_MODEL: 'setPropertyModel',
        UPDATE_PROPERTY: 'updateProperty',
        DELETE_PROPERTY: 'deleteProperty',
        LIST_OF_ADDRESSES: 'setListOfAddresses',
        PROPERTY_DESCRIPTION: 'setPropertyDescription',
        PROPERTY_SUBCATEGORY: 'setPropertySubcategory',
        ASSIGNVALUE_DESCRIPTION: 'assignValueForDescription',
        ASSIGNVALUE_SUBCATEGORY: 'assignValueForSubcategory',
        LOCATION: 'setLocationByAddress',
        LIST_OF_CRITERIAS: 'setListOfCriterias',
        SMART_SEARCH_KEYWORD: 'setSmartSearchKeyWord',
        LIST_OF_PUBLISH_PLAN: 'setListOfPublishPlan',
        HAS_SELECTED_PORTAL: 'setHasSelectedPortal',
        HAD_SELECTED_PORTAL_BEFORE_TYPE_CHANGE: 'setHadSelectedPortalBeforeTypeChange',
        UPDATE_PROPERTY_PROP_ELEMENT: 'updatePropertyPropElement',
        ADD_PROPERTY_PROP_ELEMENT: 'addPropertyPropElement',
        DELETE_PROPERTY_PROP_ELEMENT: 'deletePropertyPropElement',
        INIT_HERITAGES: 'initHeritages',
        REFRESH_PROPERTY_DATA: 'refreshPropertyData',
        RESET_PICTURE_TAB: "resetPictureTab",
        MEDIA_PUBLIC_PLANS: "setMediaPublicPlans",
        UPDATE_MEDIA_PUBLIC_PLANS: 'updateMediaPublicPlans',
        REMOVE_MEDIA_PUBLIC_PLANS: 'removeMediaPublicPlans',
        SET_IS_SAVING: 'setIsSaving',
    }
};

export const PROJECT_STORE_TYPE = {
    GET: {
        PROJECT_BY_ID: "getProjectById",
        PROJECT_NEW: "getProjectNew",
        PROJECT_GET_CONTENT_BY_TAB_NAME: "getContentByTabNameForProject",
        PROJECT_BUILDING_INIT: "projectBuildingInit",
        LIST_OF_PROJECT_UNITS: "getListOfProjectUnits",
        LIST_OF_FINANCE_LINKED_UNITS: "getListOfFinanceLinkedUnits",
        UNITS_OF_BUILDING: "getUnitsOfBuilding"
    },
    SET: {
        PROJECT_INSERT: "insertProject",
        PROJECT_UPDATE: "projectUpdate",
        REFRESH_DATA: 'refreshProjectData'
    }
};